import { baseAxios } from "./apiDefault";
import promiseHandler from "@/utils/promise";

export const getResource = async () =>
  promiseHandler(baseAxios().get("api/v1.0/physicalResource"));

export const userServiceChangeResource = async data =>
  promiseHandler(baseAxios().put("user/api/v1.0/service/resource", data));

export const getResourceUserService = async type =>
  promiseHandler(baseAxios().get(`user/api/v1.0/service/resource/${type}`));

/*****************************Admin**************************/
export const resourcesListAdmin = async () =>
  promiseHandler(baseAxios().get("admin/api/v1.0/physicalResource/list"));
export const resourceUpdate = async data =>
  promiseHandler(
    baseAxios().put("admin/api/v1.0/physicalResource/update", data)
  );
